import { useState } from 'react';
import { DonViCoSo, KhachHang, NhanVien, TaiKhoan } from '@/types/schemas';

export interface SearchFieldState {
  khachHang: KhachHang | null;
  nhanVien: NhanVien | null;
  taiKhoanNo: TaiKhoan | null;
  revenueAccount: TaiKhoan | null;
  donVi: DonViCoSo | null;
}

export interface SearchFieldActions {
  setKhachHang: (khachHang: KhachHang | null) => void;
  setNhanVien: (nhanVien: NhanVien | null) => void;
  setTaiKhoanNo: (taiKhoanNo: TaiKhoan | null) => void;
  setRevenueAccount: (revenueAccount: TaiKhoan | null) => void;
  setDonVi: (donVi: DonViCoSo | null) => void;
  resetState: () => void;
  updateState: (updates: Partial<SearchFieldState>) => void;
}

export interface UseSearchFieldStatesReturn {
  state: SearchFieldState;
  actions: SearchFieldActions;
}

const initialState: SearchFieldState = {
  khachHang: null,
  nhanVien: null,
  taiKhoanNo: null,
  revenueAccount: null,
  donVi: null
};

function transformInitialData(initialData?: BanHangRecord): Partial<SearchFieldState> {
  if (!initialData) return {};
  return {
    khachHang: initialData.ma_kh_data || null,
    nhanVien: initialData.ma_nvbh_data || null,
    taiKhoanNo: initialData.tk_data || null,
    revenueAccount: initialData.revenue_account_data || null,
    donVi: initialData.ma_unit_data || null
  };
}

export function useSearchFieldStates(initialData?: BanHangRecord): UseSearchFieldStatesReturn {
  const [state, setState] = useState<SearchFieldState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const actions: SearchFieldActions = {
    setKhachHang: (khachHang: KhachHang | null) => {
      setState(prev => ({ ...prev, khachHang }));
    },
    setNhanVien: (nhanVien: NhanVien | null) => {
      setState(prev => ({ ...prev, nhanVien }));
    },
    setTaiKhoanNo: (taiKhoanNo: TaiKhoan | null) => {
      setState(prev => ({ ...prev, taiKhoanNo }));
    },
    setRevenueAccount: (revenueAccount: TaiKhoan | null) => {
      setState(prev => ({ ...prev, revenueAccount }));
    },
    setDonVi: (donVi: DonViCoSo | null) => {
      setState(prev => ({ ...prev, donVi }));
    },
    resetState: () => {
      setState(initialState);
    },
    updateState: (updates: Partial<SearchFieldState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
